import { render } from "./GameSearchSkeleton.vue?vue&type=template&id=6ba7474c&scoped=true"
import script from "./GameSearchSkeleton.vue?vue&type=script&lang=js"
export * from "./GameSearchSkeleton.vue?vue&type=script&lang=js"

import "./GameSearchSkeleton.vue?vue&type=style&index=0&id=6ba7474c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ba7474c"]])

export default __exports__